(function () {
  function init() {
    var bar = document.querySelector('.dbc-sticky-atc');
    if (!bar) return;
    // dbc_sticky2 05.10.2026: fixed bar was trapped in a transformed parent, move it to body
    document.body.appendChild(bar); bar.inert = true;
    var btn = bar.querySelector('.dbc-sticky-atc__btn');
    var id = btn.getAttribute('data-target');
    var section = bar.getAttribute('data-section');
    function target() { return document.getElementById(id); }
    btn.addEventListener('click', function () {
      var t = target(); if (!t) return;
      t.scrollIntoView({ block: 'center' });
      t.click();
    });
    var shown = null, ticking = false;
    function check() {
      ticking = false;
      var t = target(); if (!t) return;
      var r = t.getBoundingClientRect(); var out = r.bottom < 0 || r.top > window.innerHeight;
      if (out === shown) return;
      shown = out;
      bar.classList.toggle('is-visible', out);
      bar.setAttribute('aria-hidden', out ? 'false' : 'true'); bar.inert = !out;
      document.body.classList.toggle('dbc-sticky-atc-open', out);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    function sync() {
      var pb = document.getElementById('price-' + section), price = null;
      if (pb) { var onSale = pb.querySelector('.price--on-sale'); price = pb.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular'); }
      if (price) bar.querySelector('.dbc-sticky-atc__price').textContent = price.textContent.trim();
      var picked = document.querySelector('variant-radios input:checked, variant-selects select');
      if (picked) {
        var label = '';
        if (picked.tagName === 'SELECT') { label = picked.options[picked.selectedIndex].text; }
        else { var lab = document.querySelector('label[for="' + picked.id + '"]'); if (lab && lab.dataset.name) label = lab.dataset.name; else if (lab && lab.childNodes.length) label = lab.childNodes[0].textContent; }
        if (label && label.trim()) bar.querySelector('.dbc-sticky-atc__title').textContent = label.trim();
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) { setTimeout(sync, 400); setTimeout(sync, 1500); }
    });
    sync(); check(); setTimeout(sync, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
